import { useMutation, UseMutationResult } from 'react-query'
import { errorAlert, loadingAlert, successAlert } from '../../../utils/alert'
import { api } from '../../api'
import { localConfig } from '../../../Configs/localConfig'

interface Params {
  editar: boolean
  cod_usuario: number
  cargos_propriedade?: any[]
  cargos_propriedade_remover?: any[]
  refetchGerenciar: Function
  limpar: Function
}

export const usePostCargoPropriedade = (): {
  carregando_salvar_atribuicao: boolean
  mutate_salvar_atribuicao: (params: Params) => void
  isSuccess_salvar_atribuicao: boolean
} => {
  const mutation: UseMutationResult<Response, Error, Params> = useMutation(
    async (params: Params) => {
      const {
        editar,
        cargos_propriedade,
        cargos_propriedade_remover,
        cod_usuario,
        refetchGerenciar,
        limpar,
      } = params

      loadingAlert({ msg: 'Salvando...', id: 'loading' })

      function tipoAcao() {
        return  { cargos_propriedade: cargos_propriedade , cargos_propriedade_remover: cargos_propriedade_remover} 
      }
  
      return api
        .post(`/usuario-cargo?codConta=${localConfig()?.conta}&codCliente=${localConfig()?.codCliente}`, {
          cod_usuario: cod_usuario,
          ...tipoAcao(),
        })
        .then((response: any) => {
          successAlert(
           editar === false ? 'Cargo atribuído com sucesso!' : 'Atualizado com sucesso!',
            5000,
            'loading'
          )
          limpar()
          refetchGerenciar()
          return response
        })
        .catch((error: any) => {
          errorAlert(
           editar === false ? 'Falha ao atribuir cargo' : 'Falha ao atualizar cargo',
            5000,
            'loading'
          )
          errorAlert(error?.response?.data?.error ?? 'Falha salvar alteração!')
          throw error
        })
    }
  )

  return {
    carregando_salvar_atribuicao: mutation.isLoading,
    mutate_salvar_atribuicao: mutation.mutate,
    isSuccess_salvar_atribuicao: mutation.isSuccess,
  }
}